import type { FixedLengthTuple } from '@mntn-dev/utility-types'

export const isFixedLengthTuple = <T, L extends number>(
  array: unknown,
  length: L
): array is FixedLengthTuple<T, L> => {
  return Array.isArray(array) && array.length === length
}

export function assertFixedLengthTuple<T, L extends number>(
  array: T[],
  length: L,
  message?: string
): asserts array is FixedLengthTuple<T, L> {
  if (!isFixedLengthTuple(array, length)) {
    throw new Error(
      message ??
        `Expected array of length ${length}, got ${Array.isArray(array) ? array.length : String(array)}`
    )
  }
}
